const config = {
  version: '2022-09-22 (v2.1.0.3)'
};

export default config;
